import { deepmerge } from '@simplisafe/ewok'

// UK
import enGBAlarmMoments from './locales/en-GB/alarm-moments.json' with {
  type: 'json'
}
import enGBCommon from './locales/en-GB/common.json' with { type: 'json' }
import enGBContact from './locales/en-GB/contact.json' with { type: 'json' }
import crimeInTheUk from './locales/en-GB/crime-in-the-uk.json' with {
  type: 'json'
}
import enGBHeader from './locales/en-GB/header.json' with { type: 'json' }
import enGBMaps from './locales/en-GB/maps.json' with { type: 'json' }
import enGBShop from './locales/en-GB/shop.json' with { type: 'json' }
import enGBShopSMB from './locales/en-GB/shop.smb.json' with { type: 'json' }
import enGBSystemAdvisor from './locales/en-GB/system-advisor.json' with {
  type: 'json'
}
import enGBTest from './locales/en-GB/test.json' with { type: 'json' }

// US
import enUSAlarmMoments from './locales/en-US/alarm-moments.json'
import enUSCommon from './locales/en-US/common.json' with { type: 'json' }
import enUSContact from './locales/en-US/contact.json' with { type: 'json' }
import enUSEmailSubscriptions from './locales/en-US/email-subscriptions.json' with {
  type: 'json'
}
import enUSHeader from './locales/en-US/header.json' with { type: 'json' }
import enUSMaps from './locales/en-US/maps.json' with { type: 'json' }
import enUSShop from './locales/en-US/shop.json' with { type: 'json' }
import enUSShopSMB from './locales/en-US/shop.smb.json' with { type: 'json' }
import enUSSystemAdvisor from './locales/en-US/system-advisor.json' with {
  type: 'json'
}
import enUSTest from './locales/en-US/test.json' with { type: 'json' }

// we keep an empty translation namespace in order to force users to use a namespace
// if we don't do this, i18next will default to the first namespace we provide and that can cause some confusion
// by adding an empty translation namespace, users will get a lint error if they try to access a key without a namespace
const usResources = {
  translation: {},
  'alarm-moments': enUSAlarmMoments,
  contact: enUSContact,
  common: enUSCommon,
  'shop.smb': enUSShopSMB,
  shop: enUSShop,
  header: enUSHeader,
  maps: enUSMaps,
  'system-advisor': enUSSystemAdvisor,
  'crime-in-the-uk': crimeInTheUk,
  test: enUSTest,
  'email-subscriptions': enUSEmailSubscriptions
}

const ukResources = {
  translation: {},
  'alarm-moments': enGBAlarmMoments,
  contact: enGBContact,
  common: enGBCommon,
  'shop.smb': enGBShopSMB,
  shop: enGBShop,
  header: enGBHeader,
  maps: enGBMaps,
  'system-advisor': enGBSystemAdvisor,
  'crime-in-the-uk': crimeInTheUk,
  test: enGBTest
}

const mergedUS = deepmerge(ukResources, usResources)
const mergedUK = deepmerge(usResources, ukResources)

export const resources = {
  'en-US': mergedUS,
  'en-GB': mergedUK
}
